import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { PATHS } from '@constants';
import Icon from '@components/Icon';
import Logo from '@components/Logo';
import './styles.scss';

const Footer = () => (
  <footer className='footer'>
    <div className='row'>
      <div className='column sm-12'>
        <div className='footer__wrapper'>
          <div className='footer__logo footer-logo'>
            <div className='footer-logo__wrap'>
              <Logo />
            </div>
          </div>
          <div className='footer__links'>
            <a href='https://twitter.com/VannPositive' target='_blank' className='footer__link' rel='noreferrer'>
              <Icon type='twitter' />
            </a>
            <a href='https://www.facebook.com/vann.cancer' target='_blank' className='footer__link' rel='noreferrer'>
              <Icon type='fb' />
            </a>
            <a href='https://www.instagram.com/vann.positive/ ' target='_blank' className='footer__link' rel='noreferrer'>
              <Icon type='instagram' />
            </a>
            <a href='https://www.linkedin.com/company/vann/ ' target='_blank' className='footer__link' rel='noreferrer'>
              <Icon type='linkedin' />
            </a>
          </div>
          <div className='footer__terms link-elements text-xs tablet-text-xs mobile-label-sm'>
            <Link className='link-elements__item' to={PATHS.PRIVACY_POLICY}>Privacy Policy</Link>
            <Link className='link-elements__item' to={PATHS.TERMS}>Terms and conditions</Link>
          </div>
          <div className='footer__copyright text-xs color-gray-3'>
            <span>Copyright © 2025 VANN. All rights reserved.</span>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
